import React from "react";
import { Header } from "../../components/SpearParts/Layouts/Header";
import { SeachSection } from "../../components/SpearParts/Layouts/SeachSection";
import { Link } from "react-router-dom";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

export const AccountHome = () => {
  const isAuthenticated = () => {
    const userInfo = sessionStorage.getItem("userInfo"); // Fetch user data
    if (userInfo) {
      const parsedData = JSON.parse(userInfo);
      return parsedData.token ? true : false;
    }
    return false;
  };

  const handleCartClick = (event) => {
    if (!isAuthenticated()) {
      event.preventDefault(); // Stop navigation
      alert("Please log in to view your cart.");
    }
  };

  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };
  return (
    <div className="New-Dashboard" style={sectionStyle}>
      {/* <Header /> */}
      <div className="Main-div">
        <TopNavBar />
        <div className="TopSearchBar">
          <TopSearchBar />
        </div>
        <section className="">
          <div className="container">
            <h3 className="text-uppercase mt-5">Account details </h3>
            <div className="row gutter-7 " style={{ marginTop: "50px" }}>
              <div className="col-lg-4">
                <Link to="/orderlist" className="account-a link-style">
                  <div className="my-account-div">
                    <h6 className="text-uppercase">Your orders</h6>
                    <p className="m-0">Track Your Orders and list</p>
                  </div>
                </Link>
              </div>
              <div className="col-lg-4">
                <Link
                  to="/viewcart/67c40bd97548cd1ef8adf542"
                  className="account-a link-style"
                  onClick={handleCartClick}
                >
                  <div className="my-account-div">
                    <h6 className="text-uppercase">Cart</h6>
                    <p className="m-0">List Of items in Cart</p>
                  </div>
                </Link>
              </div>

              <div className="col-lg-4">
                <Link to="/account/contact" className="account-a">
                  <div className="my-account-div">
                    <h6 className="text-uppercase">Contact information</h6>
                    <p className="m-0">Update Your Details Here</p>
                  </div>
                </Link>
              </div>

              <div className="col-lg-4">
                <Link to="/account/payments" className="account-a">
                  <div className="my-account-div">
                    <h6 className="text-uppercase">Payment options</h6>
                    <p className="m-0">Lorem dummy text</p>
                  </div>
                </Link>
              </div>
              <div className="col-lg-4">
                <Link to="/account/transactions" className="account-a">
                  <div className="my-account-div">
                    <h6 className="text-uppercase">Payments</h6>
                    <p className="m-0">Lorem dummy text</p>
                  </div>
                </Link>
              </div>
              <div className="col-lg-4">
                <Link to="/account/history" className="account-a">
                  <div className="my-account-div">
                    <h6 className="text-uppercase">Purchase history</h6>
                    <p className="m-0">Lorem dummy text</p>
                  </div>
                </Link>
              </div>
              <div className="col-lg-4">
                <Link to="/account/order" className="account-a">
                  <div className="my-account-div">
                    <h6 className="text-uppercase">Purchase Order</h6>
                    <p className="m-0">Lorem dummy text</p>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <Footer /> */}
    </div>
  );
};

export default AccountHome;
